import React, { FC } from "react";
import Button from "../../../../shared/ui/display/Button";
import Grid from "../../../../shared/ui/display/Grid";
import Typography from "../../../../shared/ui/display/Typography";
import useTranslations from "./useTranslations";

export type AuthSelectPhoneFormProps = {
  primaryPhoneNumber: string;
  additionalPhoneNumber: string;
  onSelect: (phoneType: "primary" | "additional") => void;
  isLoading?: boolean;
};

const AuthSelectPhoneForm: FC<AuthSelectPhoneFormProps> = ({
  primaryPhoneNumber,
  additionalPhoneNumber,
  onSelect,
  isLoading,
}) => {
  const { title } = useTranslations();

  return (
    <Grid container direction="column" wrap="nowrap" spacing={3}>
      <Grid item pb={6}>
        <Typography variant="body2">{title}</Typography>
      </Grid>
      <Grid item>
        <Button
          onClick={() => onSelect("primary")}
          disabled={isLoading}
          fullWidth
          variant="outlined"
          size="large"
        >
          {primaryPhoneNumber}
        </Button>
      </Grid>
      <Grid item>
        <Button
          onClick={() => onSelect("additional")}
          disabled={isLoading}
          fullWidth
          variant="outlined"
          size="large"
        >
          {additionalPhoneNumber}
        </Button>
      </Grid>
    </Grid>
  );
};

export default AuthSelectPhoneForm;
